import { C } from "../../styles/theme";
import { PIMG } from "../../data/initialData";
import FImg from "../common/FImg";
import PBtn from "../common/PBtn";

export default function CompareModal({ items, onClose }) {
  if (!items || items.length < 2) return null;
  const rows = [["Category", "category"], ["Price", "price"], ["Unit", "unit"], ["Stock", "stock"], ["Compatible", "compat"], ["Description", "desc"]];
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(10,20,40,.68)", zIndex: 2000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "22px 16px", overflowY: "auto", backdropFilter: "blur(4px)" }} onClick={onClose}>
      <div className="compare-modal-content" onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, paddingBottom: 12, borderBottom: `1px solid ${C.border}` }}>
          <h3 style={{ color: C.blue, fontWeight: 700, fontSize: 17, margin: 0 }}>Product Comparison</h3>
          <button onClick={onClose} style={{ background: "#f1f5f9", border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer", fontSize: 14, color: C.gray, display: "flex", alignItems: "center", justifyContent: "center" }}>x</button>
        </div>
        <div className="compare-grid-wrap">
          <div style={{ display: "grid", gridTemplateColumns: "140px repeat(" + items.length + ",1fr)", gap: 0, minWidth: 600 }}>
            <div />
            {items.map(p => (
              <div key={p.id} style={{ textAlign: "center", padding: "0 10px 14px", borderLeft: `1px solid ${C.border}` }}>
                <div style={{ height: 90, overflow: "hidden", borderRadius: 9, marginBottom: 9 }}>
                  <FImg src={PIMG[p.category]} h={90} style={{ width: "100%", height: 90, objectFit: "cover" }} />
                </div>
                <div style={{ fontWeight: 700, color: C.blue, fontSize: 13, lineHeight: 1.3 }}>{p.name}</div>
              </div>
            ))}
          </div>
          {rows.map(([label, key], ri) => (
            <div key={key} style={{ display: "grid", gridTemplateColumns: "140px repeat(" + items.length + ",1fr)", background: ri % 2 === 0 ? "#f8fafc" : "#fff", borderRadius: ri === 0 ? "8px 8px 0 0" : ri === rows.length - 1 ? "0 0 8px 8px" : "0", border: `1px solid ${C.border}`, borderBottom: ri < rows.length - 1 ? "none" : `1px solid ${C.border}`, minWidth: 600 }}>
              <div style={{ padding: "10px 12px", fontWeight: 700, color: C.blue, fontSize: 12, display: "flex", alignItems: "center" }}>{label}</div>
              {items.map(p => {
                const v = key === "price" ? "Rs." + p[key].toLocaleString() + " / " + p.unit : key === "stock" ? <span style={{ color: p.stock <= 10 ? C.red : p.stock <= 20 ? C.amber : C.teal, fontWeight: 700 }}>{p.stock + " units"}</span> : p[key];
                return <div key={p.id} style={{ padding: "10px 12px", fontSize: 12.5, color: C.gray, borderLeft: `1px solid ${C.border}`, display: "flex", alignItems: "center" }}>{v}</div>;
              })}
            </div>
          ))}
        </div>
        <PBtn onClick={onClose} extra={{ marginTop: 16 }}>Close</PBtn>
      </div>
    </div>
  );
}
